import clsx from 'clsx';
import type { HTMLAttributes, Ref } from 'react';
import { memo, useCallback } from 'react';

import * as styles from './indicator.css';

export interface SplitViewMenuProps extends HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  setPressed: (v: boolean) => void;
}

export const SplitViewMenuIndicator = memo(
  ({
    ref,
    className,
    active,
    setPressed,
    ...attrs
  }: SplitViewMenuProps & { ref?: Ref<HTMLDivElement> }) => {
    const onMouseDown = useCallback(() => {
      const t = setTimeout(() => setPressed(true), 100);
      window.addEventListener(
        'mouseup',
        () => {
          clearTimeout(t);
          setPressed(false);
        },
        { once: true }
      );
    }, [setPressed]);

    return (
      <div
        ref={ref}
        data-active={active}
        data-testid="split-view-indicator"
        className={clsx(className, styles.indicator)}
        onMouseDown={onMouseDown}
        {...attrs}
      >
        <div className={styles.indicatorInner} />
      </div>
    );
  }
);

interface SplitViewIndicatorProps extends HTMLAttributes<HTMLDivElement> {
  isDragging?: boolean;
  isActive?: boolean;
  listeners?: any;
  setPressed?: (pressed: boolean) => void;
}

export const SplitViewIndicator = ({
  isDragging,
  isActive,
  listeners,
  setPressed,
}: SplitViewIndicatorProps) => {
  const active = isActive || isDragging;

  return (
    <div data-is-dragging={isDragging} className={styles.indicatorWrapper}>
      <SplitViewMenuIndicator
        active={active}
        setPressed={setPressed}
        {...listeners}
      />
    </div>
  );
};
